import React, { ReactElement } from 'react'
import {
  Flex,
  Text,
  IText,
  formatPrice,
  theme,
} from '@mindfulchefuk/design-system'

type TRecipeModalPriceStat = IText & {
  price: number
  pricePerPerson: number
  title: string
}

export const RecipeModalPriceStat = ({
  price,
  pricePerPerson,
  title,
  ...textProps
}: TRecipeModalPriceStat): ReactElement => {
  const formattedPrice = formatPrice(price, true)
  const formattedPricePerPerson = formatPrice(pricePerPerson, true)
  return (
    <Flex direction="column" mr={28}>
      <Text variant="body-md" color={theme.colors['pepper-500']}>
        {title}
      </Text>
      <Flex direction="row">
        <Text variant="body-md-500-caps" color="pepper-500" {...textProps}>
          {formattedPrice}
        </Text>
        <Text variant="body-md" color="pepper-500" {...textProps} ml={4}>
          ({formattedPricePerPerson} pp)
        </Text>
      </Flex>
    </Flex>
  )
}
